import { combineReducers } from 'redux';
import lockerReducer from './lockerReducer';
import sessionReducer from './sessionReducer';
import kioskDataReducer from './kioskDataReducer';
import devicesReducer from './devicesReducer';

const reducers = combineReducers({
  locker: lockerReducer,
  session: sessionReducer,
  kioskData: kioskDataReducer,
  devices: devicesReducer
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
